// extracted by mini-css-extract-plugin
export var content = "_6v-1";
export var modal = "_6v-0";